module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a3-2-aa63339904e0618b4e12adfc518ba1be.jpg";